import type { MegaMenuItem, MegaMenuSubItem } from "@/features/navigation/components/MegaMenu/types/megaMenu.types";
import {
  MEGA_MENU_CHILD_DESCRIPTIONS,
  MEGA_MENU_ENRICHMENT,
} from "@/features/navigation/config/menuBehaviors";
import { resolveIcon } from "@/features/navigation/utils/iconResolver";
import type { ApiMenuItem } from "@/features/theme/types/brandTheme.type";

const transformChild = (child: ApiMenuItem): MegaMenuSubItem => ({
  to: child.route ?? "",
  label: child.label,
  description: MEGA_MENU_CHILD_DESCRIPTIONS[child.key],
  icon: resolveIcon(child.icon, child.icon_type, child.icon_variant, child.icon_image),
});

export const transformToMegaMenu = (items: ApiMenuItem[]): MegaMenuItem[] =>
  items.map((item) => {
    const enrichment = MEGA_MENU_ENRICHMENT[item.key];
    const children = item.children ?? [];
    const hasChildren = children.length > 0;

    return {
      id: item.key,
      label: item.label,
      icon: resolveIcon(item.icon, item.icon_type, item.icon_variant, item.icon_image),
      to: !hasChildren ? (item.route ?? undefined) : undefined,
      submenu: hasChildren ? children.map(transformChild) : undefined,
      featuredContent: enrichment?.featuredContent,
      columns: enrichment?.columns,
    };
  });
